//import store from "@/store";
import Vue from "vue";
/**
 * requestInterceptor
 * @description Intercepts all request to Connector app
 */
export const requestInterceptor = async (req) => {
  const keycloak = Vue.prototype.$keycloak;

  const refreshBuffer = parseInt(process.env.VUE_APP_KEYCLOAK_REFRESH_TOKEN, 10) || 30;
  try {
    await keycloak.updateToken(refreshBuffer);
    req.headers["Authorization"] = `Bearer ${keycloak.token}`;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    keycloak.login({
      redirectUri: `${process.env.VUE_APP_HOME_URI}`,
    });
  }

  return req;
};
